import React, { useEffect,  } from "react";

import styled from "styled-components";
// import { getPopmenuInfo } from '@/api/base'
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'
import btnImg from './img/按钮-1.png'
import OpenApp from '../../components/OpenApp';
import { connect } from 'react-redux';
import h5Share from '@/utils/h5Share'
import { handleUploadTrace, jumpTo } from '@/utils'
// import { ModalContainer } from "../sku-exchange/style";
const Active_147 = ({token}) => {
  const active_id =  147;


    // const [showAddr,setShowAddr] = useState(false);
  const isStorm = bwmodel.app === 'storm';

  const userAgentInfo = navigator.userAgent;
  const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
   const mobileFlag = mobileAgents.some((mobileAgent) => {
      return userAgentInfo.indexOf(mobileAgent) > 0;
  });

  useEffect(() => {
    document.title = '智慧主升浪」— 解读市场趋势，抓住财富脉搏';
     document.body.style = "background-color:#25252E !important;"
    handleUploadTrace('ActivityPagelyuan')

    h5Share.main({
      title: `「智慧主升浪」— 解读市场趋势，抓住财富脉搏`,
      desc: '1对1交流，盘面提示，市场方向，热点题材，市场先机，投研分享，排雷锦囊，投资组合。',
      link: process.env.REACT_APP_DEMAND_URL + 'active_'+ active_id,
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
    smoothscroll.polyfill();

    // getData();

  }, [])



  const handleLeftClick = () => {
    // const bool =  showPopMenu && (count===0);
    // if(bool) {
    //   setShowModal(true);
    // } else {
    //   console.log('返回');
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    // }
  }

 

  return (
    <div>
      {
        isStorm && <Header
          title={'智慧主升浪'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
          right={
              bwmodel.compareVersion('4.17.9') ?( <img
              onClick={()=> {
                bridge.callHandler('nativeEvent', {
                    event: 'shareLink',
                    params: {
                      // shareLinkParams:{
                      title: `「智慧主升浪」— 解读市场趋势，抓住财富脉搏`,
                      desc: '1对1交流，盘面提示，市场方向，热点题材，市场先机，投研分享，排雷锦囊，投资组合。',
                      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
                      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_147',
                    }
                  })
              }}
              style={{width:'20px','vertical-align': 'middle'}}
              src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)}
              alt="分享"
            />
              )
          :''
          }
            
        />
      }

      {
        !mobileFlag && <Container style={{marginTop: isStorm?'44px':'0px'}} className={mobileFlag?'mobileFlag':''}>
        {/* <img className="first" src={require('./img/首图@2x.png')} alt="市值风云" /> */}
        <img className="member-img" src={require('./img/Slice1@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice2@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice3@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice4@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice5@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice6@2x.png')} alt="市值风云" />
        
        <img className="member-img"
           style={{cursor: 'pointer'}}
            onClick={()=>{
           jumpTo(window.location.origin + '/activity/active_147/code')
          }} src={require('./img/Slice7@2x.png')} alt="市值风云" />
        
       
 
       </Container>
      }

      {
        mobileFlag && <Container style={{marginTop: isStorm?'44px':'0px'}} className={mobileFlag?'mobileFlag':''}>
       {/* <img className="first" src={require('./img/首图@2x.png')} alt="市值风云" /> */}
       <img className="member-img" src={require('./img/pic1@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic2@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic3@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic4@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic5@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic6@2x.png')} alt="市值风云" />
      
       {
        !mobileFlag && <img className="member-img"
          style={{cursor: 'pointer'}}
           onClick={()=>{
          jumpTo(window.location.origin + '/activity/active_147/code')
         }} src={require('./img/按钮-1.png')} alt="市值风云" />
       }  
      
       {
        mobileFlag &&  <div className="footer footer-freeclass-block" id="footer">
        <div className="btn" 
          onClick={()=>{
            jumpTo(window.location.origin + '/activity/active_147/code')
          }
        }>
        </div>
      </div>
       }

      </Container>
      }
      {
        !isStorm && mobileFlag &&  <OpenApp bottom = '80'  url={`${process.env.REACT_APP_DEMAND_URL}active_147`}></OpenApp>
      }
    </div>
  )
}

const Container = styled.div`
  background: #050B2D;
  max-width: 1080px;
  margin: 0 auto;
  &.mobileFlag {
   padding-bottom:30vw;
   max-width: 100%;
  }
  img {
    vertical-align: middle;
    font-size:0;
    width:100%;
  }

  .first {
    margin-bottom: -37vw;
  }
  .member-img {
    box-sizing: border-box;;
  }
    .tips2 {
      padding: 0;
      margin:0;
      font-weight: 300;
      font-size: 12px;
      color: #9696A6;
      line-height: 17px;
      text-align: center;
      font-style: normal;

    }
    .footer {
      // height: 65px;
      background: #050B2D;
      box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
      //  padding: 5px 4.1vw 0px;
       position: fixed;
      left: 0;
      right: 0;
      bottom: -126px;
     
      z-index: 10;
      transition: bottom 0.5s;
      &.footer-freeclass-block {
          bottom: 0;
      }
      .tips{
        padding: 10px;
        color: #FFF;
        text-align:center;
        time {
          color: #FFCD88;
        }
      }
      .btn {
        height: 28.6vw;
        background: linear-gradient( 270deg, #5376EC 0%, #F5725B 100%);
        background-image: url(${btnImg});
        background-size: 100% 100%;
        border-radius: 22px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        position: relative;
        line-height: 44px;
        
        >span {
          position: absolute;
          right: 0px;
          width: 70px;
          height: 20px;
          background: #FF3446;
          border-radius: 0px 8px 0px 8px;
          color: #FFFFFF;
          text-decoration: line-through;
          top:0px;
          font-size:12px;
          line-height: 17px;
            
        }
      }
    }
@keyframes liuguang {
  00% {
    left: -105px;
  }

  20% {
    left: -15px;
  }
 
 
  100% {
    left: 50vw;
  }
}

.fixed_box {
  position: fixed;
  bottom: 120px;
  width: 48px;
  right: 10px;
}
`
// const ModalContainer = styled.div`
//   .modalCon {
//       position: relative;
//       img {
//         width:68.2vw;
//       }

//   }
//   .tips {
//     color: #FFFFFF;
//     position: absolute;
//     width:100%;
//     text-align:center;
//     top: 31vw;
//   }
//   .close {
//     display: block;
//     margin: 10px auto 0;
//   }
// `

// const ModalView =  styled.div`
//   position: fixed;
//   left: 0;
//   top: 0;
//   overflow: hidden;
//   width: 100%;
//   height: 100%;
//   z-index: 1000;
//   display: inline-block;
//   .bg {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0,0,0,0.5);
//     z-index: 10;
//   }
//   .con {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 11;
//   }

// `


const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(Active_147))



// WEBPACK FOOTER //
// ./src/views/activity_147/index.js